import { render, staticRenderFns } from "./MobileBoxControls.vue?vue&type=template&id=923b6b24&scoped=true"
import script from "./MobileBoxControls.js?vue&type=script&lang=js&external"
export * from "./MobileBoxControls.js?vue&type=script&lang=js&external"
import style0 from "./MobileBoxControls.scss?vue&type=style&index=0&id=923b6b24&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923b6b24",
  null
  
)

export default component.exports